export var fundFees = [{
  id: 'MGR',
  label: 'Comisión de gestión',
  tooltip: {
    title: 'Comisión de gestión',
    text: 'Es la comisión del fondo.'
  }
}, {
  id: 'SUC',
  label: 'Comisión de éxito',
  tooltip: {
    title: 'Comisión de éxito',
    text: 'Es la comisión de éxito.'
  }
}, {
  id: 'CUS',
  label: 'Comisión de custodia',
  tooltip: {
    title: 'Comisión de custodia',
    text: 'Es la comisión de custodia.'
  }
}, {
  id: 'OGC',
  label: ['Gastos', 'corrientes'],
  tooltip: {
    title: 'Gastos corrientes',
    text: 'Los gastos corrientes del fondo.'
  }
}, {
  id: 'FLO',
  label: 'Comisión de suscripción',
  tooltip: {
    title: 'Comisión de suscripción',
    text: 'Es la comisión de suscripción.'
  }
}, {
  id: 'RED',
  label: 'Comisión de reembolso',
  tooltip: {
    title: 'Comisión de reembolso',
    text: 'Es la comisión de reembolso.'
  }
}, {
  id: 'TER',
  label: 'TER',
  tooltip: {
    title: 'TER',
    text: 'Es el ratio total de gastos.'
  }
}, {
  id: 'DLO',
  label: 'DLO',
  tooltip: {
    title: 'DLO',
    text: 'DLO.'
  }
}];